module.exports = __webpack_public_path__ + "img/point4_rollingBg.33d88687.png";